import React from 'react';
import { Plus, Trash } from '@phosphor-icons/react';
import { Button, Input, Textarea } from 'app/components';
import { generateUniqueId } from '../../../utils/commonUtils';

const MOCK = [{
  id: '1',
  category: 'Music',
  price: '1100',
  details: 'ksfmclzxmcdosfjbfesdpx cs xlmvkfdvcx',
},{
  id: '2',
  category: 'Concert',
  price: '500',
  details: 'Music concert in chennai',
}];

const TicketBuilder = (props) => {
  const {
    tickets = MOCK,
    onChange,
  } = props;

  const onAdd = () => {
    const updatedTickets = [...(tickets || [])];
    updatedTickets.push({
      id: generateUniqueId(),
      category: '',
    });

    onChange(updatedTickets);
  };

  const onDelete = (index) => {
    const updatedTickets = [...(tickets || [])];
    updatedTickets.splice(index, 1);

    onChange(updatedTickets);
  };

  const onChangeValue = (key, value, index) => {
    const updatedTickets = [...(tickets || [])];
    updatedTickets[index] = {
      ...updatedTickets[index],
      [key]: value,
    };

    onChange(updatedTickets);
  };

  return (
    <div className="flex flex-col gap-4">
      {tickets?.map((ticket, idx) => (
        <div
          key={ticket?.id}
          className="flex gap-8"
        >
          <Input
            label="Category"
            value={ticket?.category}
            onChange={(e) => onChangeValue('category', e?.target?.value, idx)}
          />
          <Input
            label="Price"
            value={ticket?.price}
            onChange={(e) => onChangeValue('price', e?.target?.value, idx)}
          />
          <Textarea
            label="Details"
            value={ticket?.details}
            onChange={(e) => onChangeValue('details', e?.target?.value, idx)}
          />
          <Trash
            size={25}
            className="shrink-0 self-center cursor-pointer"
            onClick={() => onDelete(idx)}
          />
        </div>
      ))}
      <Button
        type="tertiary"
        size="small"
        iconLeft={<Plus />}
        onClick={onAdd}
      >
        Add a Category
      </Button>
    </div>
  );
};

export default TicketBuilder;